import { render, staticRenderFns } from "./groupsForm.vue?vue&type=template&id=77165096"
import script from "./groupsForm.vue?vue&type=script&lang=js"
export * from "./groupsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports